import { queryClient } from '../queryClient';

import { WatchedAsset } from './types';

export function getWatchingProgress(asset: WatchedAsset) {
  return (asset.position / asset.duration) * 100;
}

export function invalidateContinueWatchingCache() {
  queryClient.invalidateQueries({ queryKey: ['CONTINUE_WATCHING'] });
}
